import { useOnboardingWizard } from "./OnboardingWizardProvider";
import { SplashStep } from "./steps/SplashStep";
import { FormStep } from "./steps/FormStep";
import { ActionConfirmationStep } from "./steps/ActionConfirmationStep";
import { InstructionStep } from "./steps/InstructionStep";
import { PollingStep } from "./steps/PollingStep";
import { CompletionStep } from "./steps/CompletionStep";

export function WizardStepRenderer() {
  const { stepConfig } = useOnboardingWizard();

  const stepComponents: Record<string, React.ComponentType> = {
    splash: SplashStep,
    form: FormStep,
    action_confirmation: ActionConfirmationStep,
    instruction: InstructionStep,
    polling: PollingStep,
    completion: CompletionStep,
  };

  const StepComponent = stepComponents[stepConfig.type];
  if (!StepComponent) return null;

  return (
    <div
      key={stepConfig.id}
      className="animate-in fade-in slide-in-from-bottom-4 duration-500"
    >
      <StepComponent />
    </div>
  );
}
